import React, { useState } from 'react'
import { StructureContainer, StructureHeader, Title } from '../style'
import InputFiles from '../../../../../components/ui/InputFiles'
import { EditInfosAbout, Image, ImageContainer, ImageInfo, ImagesContainer, RemoveImage, TitleOrSubtitle, TitleOrSubtitleInput } from './style'
import { ImageIcon, Pen, X } from 'lucide-react'

interface ImageData {
  id?: number
  file?: File
  fileUrl?: string
  customName: string
  isEditing: boolean
  subtitle?: string
}

interface ImagesInTheCertificateProps {
  images: ImageData[]
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>
}

const ImagesInTheCertificate:React.FC<ImagesInTheCertificateProps> = ({ images, setImages }) => {
  const handleAddImage = (file: File) => {
    setImages([...images, {
      file,
      customName: file.name,
      isEditing: false,
    }])
  }

  const handleRemoveImage = (index: number) => {
    setImages(images.filter((_, i) => i !== index))
  }

  const handleStartEditing = (index: number) => {
    setImages(images.map((img, i) => 
      i === index ? { ...img, isEditing: true } : img
    ))
  }

  const handleSaveEdit = (index: number, newName: string) => {
    setImages(images.map((img, i) => 
      i === index ? { ...img, customName: newName, isEditing: false } : img
    ))
  }

  const handleCancelEdit = (index: number) => {
    setImages(images.map((img, i) => 
      i === index ? { 
        ...img, 
        customName: img.file ? img.file.name : img.customName, 
        isEditing: false 
      } : img
    ))
  }

  const getImageSrc = (imageData: ImageData) => {
    if (imageData.file) {
      return URL.createObjectURL(imageData.file)
    }
    if (imageData.fileUrl) {
      return imageData.fileUrl
    }
    return ''
  }

  const getImageSize = (imageData: ImageData) => {
    if (imageData.file) {
      return (imageData.file.size / 1024 / 1024).toFixed(1)
    }
    return 'N/A'
  }
  
  return (
    <StructureContainer>
      <StructureHeader style={{marginBottom: '30px'}}>
        <Title>Imagens no Certificado</Title>
      </StructureHeader>
      <InputFiles handleAddImage={handleAddImage} />
      <ImagesContainer>
        {images.map((imageData, index) => (
          <ImageContainer key={index}>
            <RemoveImage onClick={() => handleRemoveImage(index)}>
              <X size={18} strokeWidth={3} />
            </RemoveImage>
            <Image draggable={false} src={getImageSrc(imageData)} alt={imageData.customName} />
            <ImageInfo>
              <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                <ImageIcon size={18} />
                <span>{getImageSize(imageData)} MB</span>
              </div>

              <EditInfosAbout style={{marginBottom: '.5rem'}}>
                <span>Título da imagem</span>
                {imageData.isEditing ? (
                  <TitleOrSubtitleInput 
                    autoFocus
                    value={imageData.customName}
                    onChange={(e) => {
                      setImages(images.map((img, i) => 
                        i === index ? { ...img, customName: e.target.value } : img
                      ))
                    }}
                    onKeyDown={(e) => {
                      if(e.key === 'Enter') {
                        handleSaveEdit(index, imageData.customName)
                      } else if(e.key === 'Escape') {
                        handleCancelEdit(index)
                      }
                    }}
                    onBlur={() => handleSaveEdit(index, imageData.customName)}
                  />
                ) : (
                  <TitleOrSubtitle onClick={() => handleStartEditing(index)}>
                    {imageData.customName}
                    <Pen size={14} />
                  </TitleOrSubtitle>
                )}
              </EditInfosAbout>
              
              <EditInfosAbout>
                <span>Subtítulo da imagem</span>
                <TitleOrSubtitleInput value={imageData.subtitle} onChange={(e) => {
                  setImages(images.map((img, i) => 
                    i === index ? { ...img, subtitle: e.target.value } : img
                  ))
                }} />
              </EditInfosAbout>
              
            </ImageInfo>
          </ImageContainer>
        ))}
      </ImagesContainer>
    </StructureContainer>
  )
}

export default ImagesInTheCertificate